<div
  class="pa-orgp"
  [class.pa-orgp--setup]="variant() === 'setup'"
  [class.pa-orgp--pill]="variant() === 'pill'"
  [class.pa-orgp--chip]="variant() === 'chip'">
  @switch (variant()) {
    @case ('setup') {
      <button
        type="button"
        class="pa-orgp__trigger pa-orgp__trigger--setup"
        [class.pa-orgp__trigger--open]="open()"
        (click)="toggle()"
        [attr.aria-expanded]="open()"
        data-testid="pa-org-picker-trigger">
        <span class="pa-orgp__icon" aria-hidden="true"
          ><i class="ph ph-buildings"></i
        ></span>
        <span class="pa-orgp__label">
          <span class="pa-orgp__name">{{ activeName() }}</span>
        </span>
        @if (open()) {
          <span class="pa-orgp__chev" aria-hidden="true"
            ><i class="ph ph-caret-up"></i
          ></span>
        } @else {
          <span class="pa-orgp__change" aria-hidden="true"
            ><i class="ph ph-arrows-left-right"></i> Change</span
          >
        }
      </button>
    }
    @case ('pill') {
      <button
        type="button"
        class="pa-orgp__trigger pa-orgp__trigger--pill"
        [class.pa-orgp__trigger--open]="open()"
        (click)="toggle()"
        [attr.aria-expanded]="open()"
        data-testid="pa-org-picker-trigger">
        <span class="pa-orgp__icon" aria-hidden="true"
          ><i class="ph ph-buildings"></i
        ></span>
        <span class="pa-orgp__name">{{ activeName() }}</span>
        <span class="pa-orgp__change" aria-hidden="true"
          ><i class="ph ph-arrows-left-right"></i> Change</span
        >
        <span class="pa-orgp__chev" aria-hidden="true"
          ><i
            class="ph"
            [class.ph-caret-up]="open()"
            [class.ph-caret-down]="!open()"></i
        ></span>
      </button>
    }
    @case ('chip') {
      <button
        type="button"
        class="pa-orgp__trigger pa-orgp__trigger--chip"
        [class.pa-orgp__trigger--open]="open()"
        (click)="toggle()"
        [attr.aria-expanded]="open()"
        data-testid="pa-org-picker-trigger">
        <span class="pa-orgp__icon" aria-hidden="true"
          ><i class="ph ph-buildings"></i
        ></span>
        <span class="pa-orgp__name">{{ activeName() }}</span>
        <span class="pa-orgp__edit" aria-hidden="true"
          ><i
            class="ph"
            [class.ph-caret-up]="open()"
            [class.ph-caret-down]="!open()"></i
        ></span>
      </button>
    }
  }

  @if (open()) {
    <div
      class="pa-orgp__menu"
      [class.pa-orgp__menu--pill]="variant() === 'pill'"
      [class.pa-orgp__menu--chip]="variant() === 'chip'"
      [@.disabled]="reduceMotion"
      @menuFade
      role="listbox"
      data-testid="pa-org-picker-menu">
      @for (org of orgs(); track org.id) {
        <button
          type="button"
          class="pa-orgp__option"
          [class.pa-orgp__option--selected]="org.id === activeId()"
          role="option"
          [attr.aria-selected]="org.id === activeId()"
          (click)="choose(org.id)">
          <span class="pa-orgp__o-icon" aria-hidden="true"
            ><i class="ph ph-buildings"></i
          ></span>
          <span class="pa-orgp__o-label">
            <span class="pa-orgp__o-name">{{ org.name }}</span>
            @if (org.meta) {
              <span class="pa-orgp__o-meta">{{ displayMeta(org.meta) }}</span>
            }
          </span>
          @if (org.id === activeId()) {
            <span class="pa-orgp__o-check" aria-hidden="true"
              ><i class="ph ph-check-circle ph-fill"></i
            ></span>
          }
        </button>
      }
    </div>
  }
</div>
